export default __webpack_public_path__ + "static/media/banner_consulsteel.4a81103b.png";